/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Rolefilteraspect3Inputs */



/**

* @param {_Class_Rolefilteraspect3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_rolefilteraspect3 = /** @type {((inputs?: _Class_Rolefilteraspect3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Rolefilteraspect3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("besitzt")
});
export { _class_rolefilteraspect3 as "_class_RoleFilterAspect" }